import './styles.css';
import { JervisUi, selectPlaceholderKey } from '@jervis/ui';
import { createPinia } from 'pinia';
import { computed, createApp, watch } from 'vue';
import { onUnauthorized } from './api.js';
import App from './App.vue';
import { createAppI18n } from './i18n.js';
import { startDesktopServices } from './lib/desktop-services.js';
import { createAppRouter } from './router.js';
import { applyDocumentLocale, usePreferencesStore } from './stores/preferences.js';
import { useSessionStore } from './stores/session.js';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

const preferences = usePreferencesStore(pinia);
const i18n = createAppI18n(preferences.locale);
applyDocumentLocale(preferences.locale);
watch(
  () => preferences.locale,
  (locale) => {
    i18n.global.locale.value = locale;
  },
);

app.use(i18n);
app.use(JervisUi);
app.provide(
  selectPlaceholderKey,
  computed(() => i18n.global.t('common.selectPlaceholder')),
);

const router = createAppRouter();
app.use(router);

const session = useSessionStore(pinia);
onUnauthorized(() => {
  if (session.isAuthenticated) {
    session.reset();
  }
  void router.push({ name: 'login' });
});

// Desktop shell only (no-op in a browser tab): once signed in, reopen the scanner, refresh the
// reference cache and replay the offline outbox; stop again on sign-out (WP7.8b).
let stopDesktopServices: (() => void) | null = null;
watch(
  () => session.isAuthenticated,
  (authenticated) => {
    stopDesktopServices?.();
    stopDesktopServices = authenticated ? startDesktopServices() : null;
  },
  { immediate: true },
);

app.mount('#app');
